import * as React from "react";

// eslint-disable-next-line no-restricted-imports
import { AppButtonProps, useAppButton } from "@1js/acui-button/lib/Next";

import { renderRibbonControlLabel } from "./renderRibbonControlLabel";
import { RibbonButtonProps, RibbonButtonState } from "./RibbonButton.types";
import { useRibbonButtonVariant } from "./useRibbonButtonVariant";

export const useRibbonButton = (
  props: RibbonButtonProps,
  ref: React.Ref<HTMLButtonElement>
): RibbonButtonState => {
  const { dataAutomationType, label, onRenderText, size, variant, variantId } =
    props;

  const appButtonState = useAppButton(
    {
      ...props,
      children: renderRibbonControlLabel(label, size, onRenderText),
      dataAutomationType: dataAutomationType ?? "RibbonButton",
    } as AppButtonProps,
    ref
  );

  useRibbonButtonVariant(
    appButtonState as RibbonButtonState,
    variant as RibbonButtonState["variant"],
    variantId as RibbonButtonState["variantId"]
  );

  return appButtonState;
};
